import MessageBroker from "@bonprix/pattern-library/components/message-broker";
import Messages from "../messages";
import fetchWithCSRF from "../../helper/fetch-with-csrf";
import Url from "../../helper/url";
import Landmark from "../landmark-adapter";
import Logger from '../logger';
import TrackingHelper from '../tracking/helper.js';

export default async function addToCart(
    digistyleId,
    shopId,
    itemId,
    itemNumber,
    itemOptionId,
    itemOptionName,
    promotionCode,
    wishlistItemId = null,
    origin = null,
    price,
    quantity,
    pointOfSaleId,
    masterStyleId,
    filterTrackingValue,
    rankingTrackingValue
) {
    const body = new FormData();
    if (digistyleId) {
        body.append('digistyleId', digistyleId);
    }
    if (itemId) {
        body.append('itemId', itemId);
    }
    if (itemOptionId) {
        body.append('itemOptionId', itemOptionId);
    }
    if (shopId !== undefined && shopId !== null) {
        body.append('shopId', shopId);
    }
    if (origin) {
        body.append('origin', origin);
    }
    if (pointOfSaleId) {
        body.append('pointOfSaleId', pointOfSaleId);
    }
    if (filterTrackingValue) {
        body.append('filterTrackingValue', filterTrackingValue);
    }
    if (rankingTrackingValue) {
        body.append('rankingTrackingValue', rankingTrackingValue);
    }

    try {
        const url = Url.toAbsolute("/list/cart/");
        const options = {method: "POST", body};
        const response = await fetchWithCSRF(url, options);

        if (!response.ok) {
            Logger.info(`response error while adding item digistyleId: ${digistyleId}, itemId: ${itemId}, itemOptionId: ${itemOptionId} to cart`, response.body);
            return;
        }

        const cartSummary = await response.json();

        const eventId = TrackingHelper.generateUUID()

        MessageBroker.publish(Messages.CART.ITEM_ADD_SUCCESS, {cartSummary, wishlistItemId, eventId, price});

        Landmark.sendLandmark({
            landmark: 'action',
            addArtGr: itemOptionName,
            addItemoptionId: itemOptionId,
            addArtNr: itemNumber + promotionCode,
            addItemId: !itemOptionId ? itemId : '',
            addMenge: quantity,
            addOrigin: origin,
            addShop: shopId,
            addStyle: masterStyleId,
            addDigistyleId: digistyleId,
            addArtPreis: price,
            addFktId: pointOfSaleId,
            eventId: eventId
        });

        return cartSummary;
    } catch (error) {
        Logger.info(`network error while adding item digistyleId: ${digistyleId}, itemId: ${itemId}, itemOptionId: ${itemOptionId} to cart`, error);
    }
}
